<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-list-check"></i>
    <!-- a block reaches the prefix slot only with a single root element -->
    @if (context == 'candidate') {
    <span scActivityPrefix>{{ texts.shortlistedByPrefix[language] }}</span>
    }
    @if (context == 'candidate') {
    {{ texts.shortlistedBySuffix[language] }}
    } @else {
    {{ texts.shortlistedPrefix[language] }} <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> {{ texts.shortlistedSuffix[language] }}
    }
</sc-activity-list-item>
